/**
 * @fileoverview GET handler for the "/engagement/segments/:id/engagements" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsIdEngagements } from "./constants";
import type { SegmentEngagementsResult } from "./types";

export const getSegmentEngagements = reactQueryFetcherAdapter(
  engagementSegmentsIdEngagements,
  (signal: AbortSignal, segmentId: string): Promise<SegmentEngagementsResult> => {
    return fetch(`/engagement/segments/${segmentId}/engagements`, "GET", {}, { signal });
  }
);
